import React from "react";
import FeedIn from "../FramerMotion/FeedIn";

const PreloadImage = ({ imgUrl, alt, className, loaded }) => {
  if (!loaded) return <div className={className} />;

  return (
    <FeedIn>
      <img src={imgUrl} alt={alt} className={className} />
    </FeedIn>
  );
};

export default PreloadImage;
